<template>
  <div class="year-report">
    <div class="yinyue-pause" @click="startOrPause" v-if="isPause"></div>
    <audio autoplay loop id="music" :src="'https://h5.hunteron.com/music/yearbg12.mp3'"></audio>
  </div>
</template>
<style scoped lang="scss">
.animate-t {
  transition-timing-function: ease-out;
  transition-duration: 0.6s;
}

.fade-right-in {
  transform: translateX(100px);
  opacity: 0;
}

.fade-right-in.animate-in {
  transform: translateX(0);
  opacity: 1;
}

.flip-left-in {
  transform: perspective(2500px) rotateY(-100deg);
  opacity: 0;
}

.flip-left-in.animate-in {
  transform: perspective(2500px) rotateY(0);
  opacity: 1;
}

.fade-up-in {
  transform: translate3d(0, 100px, 0);
  opacity: 0;
}

.fade-up-in.animate-in {
  transform: translate3d(0, 0, 0);
  opacity: 1;
}

.fade-left-in {
  transform: translateX(-100px);
  opacity: 0;
}
.fade-left-in.animate-in {
  transform: translateX(0);
  opacity: 1;
}

.fade-zoom-in {
  transform: scale(0.6);
  opacity: 0;
}
.fade-zoom-in.animate-in {
  transform: scale(1);
  opacity: 1;
}

.year-report {
  height: 100%;
  max-width: 75rem;
  margin: auto;
  overflow: hidden;
  position: relative;
  font-size: 16px;
  font-weight: 500;
  color: #ffffff;
  line-height: 24px;
  p {
    white-space: nowrap;
    &.normal {
      white-space: normal;
    }
  }
  .yinyue-bg {
    background: url("../../assets/yearReport/yinyuebg@2x.png") center center
      no-repeat;
    height: 30px;
    width: 30px;
    background-size: 30px 30px;
    position: fixed;
    right: 15px;
    top: 15px;
    z-index: 99;
    text-align: center;
  }
  .yinyue-pause {
    background: url("../../assets/yearReport/pause@2x.png") center center
      no-repeat;
    height: 30px;
    width: 30px;
    background-size: 30px 30px;
    position: fixed;
    right: 15px;
    top: 15px;
    z-index: 99;
    text-align: center;
  }
  @keyframes rollin {
    from {
      transform: rotateZ(0deg);
    }
    to {
      transform: rotateZ(360deg);
    }
  }
  .yinyue {
    height: 17px;
    &.isBegin {
      animation: 3s linear 1s infinite rollin;
    }
  }
  .light {
    background: url("../../assets/yearReport/light.png") center -10px no-repeat;
    height: 45rem;
    background-size: 32rem 45rem;
  }
  i.jin {
    height: 17px;
    width: 17px;
    display: inline-block;
    background: url("../../assets/yearReport/jin.png") center center no-repeat;
    background-size: contain;
  }
  i.yin {
    height: 17px;
    width: 17px;
    display: inline-block;
    background: url("../../assets/yearReport/yin.png") center center no-repeat;
    background-size: contain;
  }
  i.tong {
    height: 17px;
    width: 17px;
    display: inline-block;
    background: url("../../assets/yearReport/tong.png") center center no-repeat;
    background-size: contain;
  }
  i.heart {
    height: 13px;
    width: 16px;
    background: url("../../assets/yearReport/redheart.png") center center
      no-repeat;
    background-size: contain;
    display: inline-block;
  }
  i.fire {
    height: 16px;
    width: 15px;
    background: url("../../assets/yearReport/fire.png") center center no-repeat;
    background-size: contain;
    display: inline-block;
  }
  i.level-tag-icon {
    height: 14.5rem;
    width: 15.7rem;
    display: inline-block;
    background-size: contain;
    &.fftq {
      background: url("../../assets/yearReport/badge/fftq.png") center center
        no-repeat;
      background-size: contain;
    }
    &.fydd {
      background: url("../../assets/yearReport/badge/fydd.png") center center
        no-repeat;
      background-size: contain;
    }
    &.fyzs {
      background: url("../../assets/yearReport/badge/fyzs.png") center center
        no-repeat;
      background-size: contain;
    }
    &.gw {
      background: url("../../assets/yearReport/badge/gw.png") center center
        no-repeat;
      background-size: contain;
    }
    &.hjbf {
      background: url("../../assets/yearReport/badge/hjbf.png") center center
        no-repeat;
      background-size: contain;
    }
    &.jzzx {
      background: url("../../assets/yearReport/badge/jzzx.png") center center
        no-repeat;
      background-size: contain;
    }
    &.msnr {
      background: url("../../assets/yearReport/badge/msnr.png") center center
        no-repeat;
      background-size: contain;
    }
    &.tjdr {
      background: url("../../assets/yearReport/badge/tjdr.png") center center
        no-repeat;
      background-size: contain;
    }
    &.zjxr {
      background: url("../../assets/yearReport/badge/zjxr.png") center center
        no-repeat;
      background-size: contain;
    }
    &.zxbj {
      background: url("../../assets/yearReport/badge/zxbj.png") center center
        no-repeat;
      background-size: contain;
    }
  }
  .erweima {
    // background: url("../../assets/yearReport/erweima.png") center center
    //   no-repeat;
    // background-size: contain;
    img {
      width: 6.4rem;
      height: 6.4rem;
    }
  }
  .pk {
    height: 96px;
    background: url("../../assets/yearReport/pk.png") center center no-repeat;
    background-size: contain;
    margin: 23px 0 26px 0;
  }
  .title1 {
    background: url("../../assets/yearReport/title1.png") no-repeat;
    height: 33px;
    background-size: contain;
    margin: 23px 0 0 36px;
  }
  .title2 {
    background: url("../../assets/yearReport/title2.png") no-repeat;
    height: 33px;
    background-size: contain;
    margin: 23px 0 0 36px;
  }
  .title3 {
    background: url("../../assets/yearReport/title3.png") no-repeat;
    height: 33px;
    background-size: contain;
    margin: 23px 0 0 36px;
  }
  .title4 {
    background: url("../../assets/yearReport/title4.png") no-repeat;
    height: 33px;
    background-size: contain;
    margin-bottom: 15px;
  }
  .title4-new {
    font-size: 26px;
    font-weight: bold;
    margin-bottom: 15px;
    position: relative;
    display: inline-block;
    &::after {
      content: "";
      width: 143px;
      height: 8px;
      position: absolute;
      bottom: -7px;
      right: 82px;
      background: #dd8431;
    }
  }
  .title5 {
    background: url("../../assets/yearReport/title5.png") no-repeat;
    height: 33px;
    background-size: contain;
    margin-bottom: 15px;
  }
  .title5-new {
    font-size: 26px;
    font-weight: bold;
    margin-bottom: 15px;
    position: relative;
    display: inline-block;
    &::after {
      content: "";
      width: 143px;
      height: 8px;
      position: absolute;
      bottom: -7px;
      right: 82px;
      background: #dd8431;
    }
  }
  .title6 {
    background: url("../../assets/yearReport/title6.png") no-repeat;
    height: 35px;
    background-size: contain;
    margin: 13px 0 0 25px;
  }
  .mt24ml25 {
    margin: 24px 0 0 25px;
  }
  .mt39ml25 {
    margin: 39px 0 0 25px;
  }
  .arrow-down {
    width: 25px;
    height: 24.5px;
    cursor: pointer;
    background: url("../../assets/yearReport/arrowDown.png") no-repeat;
    background-size: contain;
    position: absolute;
    bottom: 25px;
    left: 50%;
    transform: translateX(-50%);
  }
  .start-btn {
    cursor: pointer;
    height: 43px;
    width: 205.5px;
    background: url("../../assets/yearReport/start-btn.png") no-repeat;
    background-size: contain;
    position: absolute;
    bottom: 49px;
    left: 50%;
    transform: translateX(-50%);
  }
  .share-btn {
    width: 205.5px;
    height: 43px;
    background: url("../../assets/yearReport/share-btn.png") no-repeat;
    background-size: contain;
    position: absolute;
    bottom: 38px;
    left: 50%;
    transform: translateX(-50%);
  }
  .pk-content {
    margin: 23px auto 0;
    width: 305px;
    .pk-content-title {
      border-radius: 5px;
      background: #fff;
      border: 1px solid #fff;
      font-size: 14px;
      font-weight: 500;
      color: #4d2701;
      display: flex;
      align-items: center;
      height: 27px;
    }
    .heart-content {
      width: 108px;
      .heart {
        margin: 0 7px;
      }
    }
    .fire-content {
      width: 103px;
      .fire {
        margin: -1px 6px 0 8px;
      }
    }
    .ranking {
      li {
        font-size: 16px;
        font-weight: 500;
        color: #ffffff;
        margin-bottom: 15px;
        display: flex;
        align-items: center;
        &:last-child {
          margin-bottom: 0;
        }
        i {
          margin-right: 10px;
        }
      }
    }
    .my {
      margin-top: 19px;
    }
    .plateform {
      position: relative;
      .fire-content {
        margin-left: auto;
        position: absolute;
        top: -53px;
        right: 0;
      }
      li {
        flex-direction: row-reverse;
        i {
          margin: 0 0 0 10px;
        }
      }
    }
  }
  .year-report-page {
    position: relative;
    height: 100%;
    background-size: cover;
    .mt20 {
      margin-top: 20px;
    }
    .mt27 {
      margin-top: 27px;
    }
    .mt49 {
      margin-top: 49px;
    }
    .mt45 {
      margin-top: 45px;
    }
    .mt25ml31 {
      margin: 25px 0 0 31px;
    }
    .user-avatar {
      display: flex;
      align-items: center;
      .img-content {
        height: 38px;
        overflow: hidden;
        border-radius: 50%;
        margin-right: 10px;
        text-align: center;
        img {
          max-width: 100%;
          max-height: 100%;
          line-height: 38px;
        }
      }
      .name {
        font-size: 19px;
        font-weight: 400;
        color: #ffffff;
      }
    }
    .num {
      background: #ffffff;
      opacity: 0.7;
      border-radius: 4px;
      color: #000;
      padding: 2px 2px;
      margin: 0 2px;
    }
    .year-no-border1 {
      height: 25px;
      background: url("../../assets/yearReport/year-no-border.png") no-repeat;
      background-size: contain;
      width: 133px;
      margin-left: auto;
    }
  }
  .page1 {
    background: url("../../assets/yearReport/bg/1.jpg") center center no-repeat;
    background-size: cover;
    .year-with-border {
      height: 43px;
      margin: 41px 0 0 23px;
      background: url("../../assets/yearReport/year-with-border.png") no-repeat;
      background-size: contain;
    }
    .year-report-title {
      height: 42px;
      margin: 19px 0 0 23px;
      background: url("../../assets/yearReport/yeartitle.png") no-repeat;
      background-size: contain;
    }

    .content {
      width: 305px;
      margin: 66px auto 0;
      padding: 10px 5px;
      position: relative;
      .leftTopRadius {
        width: 26px;
        height: 26px;
        background: url("../../assets/yearReport/letfTopRadius.png") no-repeat;
        position: absolute;
        top: 0;
        left: 0;
        background-size: contain;
      }
      .rightBottomRadius {
        width: 26px;
        height: 26px;
        background: url("../../assets/yearReport/rightBottomRadius.png")
          no-repeat;
        position: absolute;
        right: 0;
        bottom: 0;
        background-size: contain;
      }
      .desc {
        text-align: center;
        color: #ffffff;
        font-size: 18px;
        line-height: 27px;
        font-weight: 500;
        p {
          white-space: nowrap;
        }
      }
    }
  }
  .page2 {
    background: url("../../assets/yearReport/bg/1.jpg") center center no-repeat;
    background-size: cover;
    .thanks1 {
      height: 142px;
      background: url("../../assets/yearReport/thanks1.png") no-repeat;
      background-size: contain;
      margin: 31px 0 0 31px;
    }
    .year-no-border-content {
      width: 332px;
      text-align: right;
      margin: 15px auto 6px;
    }
    .year-no-border {
      height: 34px;
      background: url("../../assets/yearReport/year-no-border.png") no-repeat;
      background-size: contain;
      width: 113px;
      display: inline-block;
    }
    .data1 {
      width: 332px;
      background: url("../../assets/yearReport/whiteborder1.png") no-repeat;
      margin: auto;
      height: 233.5px;
      background-size: contain;
      padding: 40px 18px 20px 18px;
      font-size: 15px;
      font-weight: 500;
      color: #ffffff;
      line-height: 24px;
      .mt30 {
        margin-top: 30px;
      }
    }
  }
  .page3 {
    background: url("../../assets/yearReport/bg/3.jpg") center center no-repeat;
    background-size: cover;
    .data-content {
      font-size: 18px;
      font-weight: 500;
      color: #ffffff;
      line-height: 24px;
      div {
        position: relative;
        margin-left: 33px;
        .wave {
          width: 114.5px;
          height: 28px;
          background: url("../../assets/yearReport/wave.png") no-repeat;
          background-size: contain;
          margin-left: auto;
          position: absolute;
          right: 0;
          bottom: 6px;
        }
      }
    }
  }
  .page4 {
    background: url("../../assets/yearReport/bg/4.jpg") center center no-repeat;
    background-size: cover;
    .data2 {
      width: 329px;
      height: 275.5px;
      background: url("../../assets/yearReport/whiteborder2.png") no-repeat;
      background-size: contain;
      margin: 40px auto 0;
      padding: 40px 0 0 12px;
      font-size: 16px;
      font-weight: 500;
      color: #ffffff;
      line-height: 24px;
      position: relative;
      .year-no-border {
        background: url("../../assets/yearReport/year-no-border.png") no-repeat;
        height: 34px;
        background-size: contain;
        position: absolute;
        top: -44px;
        width: 113.5px;
        right: 0;
      }
    }
    .thanks2 {
      width: 307px;
      height: 48px;
      background: url("../../assets/yearReport/thanks2.png") no-repeat;
      margin: 47px auto 0;
      background-size: contain;
    }
  }
  .page5 {
    background: url("../../assets/yearReport/bg/5.jpg") center center no-repeat;
    background-size: cover;
  }
  .page6 {
    background: url("../../assets/yearReport/bg/6.jpg") center center no-repeat;
    background-size: cover;
  }
  .page7 {
    background: url("../../assets/yearReport/bg/7.jpg") center center no-repeat;
    background-size: cover;
  }
  .page8 {
    background: url("../../assets/yearReport/bg/8.jpg") center center no-repeat;
    background-size: cover;
    .data3 {
      width: 329px;
      height: 150px;
      background: url("../../assets/yearReport/whiteborder3.png") no-repeat;
      background-size: contain;
      margin: 26px auto 0;
      padding: 40px 0 0 12px;
      font-size: 16px;
      font-weight: 500;
      color: #ffffff;
      line-height: 24px;
      position: relative;
      .year-no-border {
        background: url("../../assets/yearReport/year-no-border.png") no-repeat;
        height: 34px;
        background-size: contain;
        position: absolute;
        top: -44px;
        width: 113.5px;
        right: 0;
      }
    }
  }
  .page9 {
    background: url("../../assets/yearReport/bg/9.jpg") center center no-repeat;
    background-size: cover;
    .top-year {
      padding: 4.2rem 2.5rem 0;
      display: flex;
      justify-content: space-between;
      .year-with-border {
        background: url("../../assets/yearReport/year-with-border.png")
          no-repeat;
        background-size: contain;
        height: 3.5rem;
        width: 9.2rem;
      }
      .logo {
        background: url("../../assets/yearReport/logo.png") no-repeat;
        background-size: contain;
        height: 3.3rem;
        width: 11rem;
      }
    }
    .level-tag {
      margin: 0.6rem auto 2.7rem;
      text-align: center;
      width: 32.3rem;
      background: url("../../assets/yearReport/star.png") no-repeat;
      background-size: contain;
    }
    .thanks3 {
      font-size: 16px;
      font-weight: 500;
      color: #ffffff;
      text-align: center;
      width: 34.5rem;
      margin: 0 auto 2.2rem;
    }
    .erweima-content {
      background: rgba(0, 0, 0, 0.12);
      width: 34.5rem;
      position: relative;
      padding: 1.6rem 0.8rem 1rem 1rem;
      margin: auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 14px;
      .desc {
        .desc-content {
          font-size: 14px;
          font-weight: 500;
          color: #ffffff;
          margin-bottom: 0.8rem;
          line-height: 2rem;
        }
      }
      .line1 {
        background: url("../../assets/yearReport/line1.png") no-repeat;
        background-size: contain;
        height: 0.8rem;
        position: absolute;
        top: 0;
        left: 0;
        width: 34.5rem;
      }
      .line2 {
        background: url("../../assets/yearReport/line2.png") no-repeat;
        background-size: contain;
        height: 2rem;
        font-size: 14px;
        font-weight: 500;
        color: #f7d399;
        padding-left: 0.5rem;
        line-height: 2rem;
      }
    }
  }
}
</style>
<style lang="scss">
.year-report {
  .van-checkbox__icon--checked .van-icon {
    border-color: #fff !important;
  }
  .agree-info {
    margin-top: 66px;
    text-align: center;
    font-size: 13px;
    .van-checkbox {
      justify-content: center;
      .van-checkbox__label {
        font-size: 13px;
        color: #fff;
      }
    }
  }
}

.wrapper-overlay {
  position: absolute;
  top: 10px;
  right: 30px;
  font-size: 17px;
  font-weight: 400;
  color: #ffffff;
  line-height: 28px;
  text-align: right;
  .img-content {
    height: 58px;
    width: 56px;
    background: url("../../assets/yearReport/arrow-top@2x.png") center center
      no-repeat;
    background-size: contain;
    display: inline-block;
  }
  p {
    text-align: left;
  }
}
</style>
<script>

export default {
  name: "year-report-module",
  components: {},
  data() {
    return {
      isPause: false,
      isAgree: false,
      isShowAgree: false,
      tagdesc: "",
      descMap: {
        精英顾问: {
          icon: "level-tag-icon gw",
          desc1: "行路不易，还好现在的你，",
          desc2: "才华横溢，未来可期",
        },
        面试牛人: {
          icon: "level-tag-icon msnr",
          desc1: "做足每一个细节，你就站在了成功的门前，",
          desc2: "再向前一步，你值得用于一切",
        },
        推荐达人: {
          icon: "level-tag-icon tjdr",
          desc1: "千里之行始于足下，今天种下推荐，",
          desc2: "明天收获Offer",
        },
        精准之星: {
          icon: "level-tag-icon jzzx",
          desc1: "君志所向，一往如前，",
          desc2: "愈挫愈奋，再接再厉",
        },
        最佳新人: {
          icon: "level-tag-icon zjxr",
          desc1: "积累着点点滴滴的收获，堆积成自信的高峰，",
          desc2: "浓缩着星星点点的能力，奋斗出傲人的成果",
        },
        风云大单: {
          icon: "level-tag-icon fydd",
          desc1: "命运的舵是奋斗，不抱有一丝幻想，不放弃",
          desc2: "一点机会，未来的你会感谢今天的坚持",
        },
        扶摇直上: {
          icon: "level-tag-icon fyzs",
          desc1: "当一个人静下心来，脚踏实地一步一个脚印",
          desc2: "向前走的时候，一个强大的自我就产生了",
        },
        厚积薄发: {
          icon: "level-tag-icon hjbf",
          desc1: "你受的苦、吃的亏、担的责、扛的罪到最后",
          desc2: "都会变成光，照亮你的路",
        },
        奋发图强: {
          icon: "level-tag-icon fftq",
          desc1: "虽然现在很辛苦，但是加油吧，再黑暗的隧道",
          desc2: "也有出口，光明一定就在前方",
        },
        朝夕不倦: {
          icon: "level-tag-icon zxbj",
          desc1: "阳光下灿烂，风雨中奔跑，",
          desc2: "做自己的梦，走自己的路",
        },
      },
      showOverlay: false,
      loading: false,
      isShare: this.$route.query.isShare,
      mp_token: this.$route.query.mp_token,
      isLast: this.$route.query.isLast,
      yearReportUUID: this.$route.query.yearReportUUID,
      currentIndex: 0,
      count: 1,
      reportData: {},
    };
  },
  methods: {
    startOrPause() {
      this.isPause = !this.isPause;
      let music = document.querySelector("#music");
      if (this.isPause) {
        music.pause();
      } else {
        music.play();
      }
    },
    beginPlay() {
      let music = document.querySelector("#music");
      if (music) {
        this.isPause = true;
        music.play();

        music.addEventListener("playing", (event) => {
          this.isPause = false;
        });

        music.addEventListener("canplaythrough", (event) => {
          console.log("canplaythrough");
          this.tagdesc = "canplaythrough";
        });
      }

      // let n = new Audio();
      // n.src =
      //   "https://qnvideo.hunliji.com/n-LvZJP0teoKD9I40PDyXmbhuJQ=/Fmtvkb2-qAsRdmMUBHMAK9Dr1KUw.mp3";
      // n.mouted = !0;
      // n.play();
      // var i = setInterval(() => {
      //   if (4 === n.readyState) {
      //     var t = n.duration,
      //       r = n.buffered.end(n.buffered.length - 1),
      //       o = r / t;
      //     console.log("readyState in autoplay,dur,end", n.readyState, t, r),
      //       console.log("readyState", n.readyState),
      //       o > 0.95 && (e(), clearInterval(i));
      //   }
      // }, 100);
    },
  },
  computed: {},
  beforeDestroy() {
    let music = document.querySelector("#music");
    music.pause();
  },
  destroyed() {},
  mounted() {
    // this.beginPlay();
    document.addEventListener("WeixinJSBridgeReady", () => {
      WeixinJSBridge &&
        WeixinJSBridge.invoke("getNetworkType", {}, () => {
          this.beginPlay();
        });
    });
  },
  created() {
    // this.beginPlay();
    
  },
};
</script>
